// src/features/executive/insight/hooks/use-new-patient-trend.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import InsightApi from 'api/executive/insight.api'
import type {
  GetInsightNewPatientTrendParams,
  InsightNewPatientTrendResponse,
  NewPatientCountMode,
} from 'api/executive/executive.types'

export function useNewPatientTrend(countMode: NewPatientCountMode = 'branch') {
  return useExecutiveQuery<GetInsightNewPatientTrendParams, InsightNewPatientTrendResponse>(
    `insight.new-patient-trend.${countMode}`,
    InsightApi.getNewPatientTrend,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        // patientType is forced to 'new' server-side; omit from client params.
        nationality: f.nationality ?? undefined,
        sourceChannel: f.sourceChannel ?? undefined,
        promotionId: f.promotionId ?? undefined,
        countMode,
      }
    },
    { extraKey: countMode }
  )
}
